export interface GERLCompany {
  id: string;
  type: 'MAIN' | 'ULTIMATE_PARENT';
}

export enum GerlRejectCode {
  COMPANY_LISTED = 'COMPANY_LISTED',
  ULTIMATE_PARENT_COMPANY_LISTED = 'ULTIMATE_PARENT_COMPANY_LISTED',
  RELATED_COMPANY_LISTED = 'RELATED_COMPANY_LISTED',
  ULTIMATE_PARENT_COMPANY_UNKNOWN = 'ULTIMATE_PARENT_COMPANY_UNKNOWN',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  POSSIBLY_LISTED = 'POSSIBLY_LISTED',
}
